module.exports = __webpack_public_path__ + "img/bg_sys.436399a5.png";